<template>
  <div>
    <div v-if="jobFormLoading" class="container">
      <spinner size="large"></spinner>
    </div>
    <div v-else class="container">
      <div class="image-container">
        <img width="40" height="40" :src="getImage">
      </div>
      <div class="mt-20">
        <h1 class="title is-4">{{getTitle}}</h1>
      </div>
      <div class="mt-8 text-align-center">
        <p>{{getMessage}} <strong v-if="!error">{{email}}</strong></p>
        <div v-if="resendButton" class="field mt-8 resend-text">
          <a @click="resendJobEmail">Resend Email</a>
        </div>
      </div>
    </div>
  </div>

</template>

<script>
import ErrorMonkey from '@/assets/error-monkey.png'
import Mailbox from '@/assets/mailbox.png'
import Spinner from 'vue-simple-spinner'
import {mapActions, mapState} from 'vuex'

export default {
  name: 'WidgetNotificationMessage',
  components: {Spinner},
  props: {
    error: {
      type: String || null,
      default: ''
    }
  },
  data () {
    return {

    }
  },
  computed: {
    ...mapState('widget', ['email', 'jobException', 'jobMessage', 'jobFormLoading']),
    resendButton () {
      return this.jobException === 'ALREADY_APPLIED'
    },
    getImage () {
      return this.error ? ErrorMonkey : Mailbox
    },
    getTitle () {
      return this.error ? "Something's wrong..." : 'Almost there...'
    },
    getMessage () {
      return this.error ? this.error : this.jobMessage
    }
  },
  methods: {
    ...mapActions('widget', ['resendEmail']),
    resendJobEmail () {
      this.resendEmail()
    }
  }
}
</script>

<style lang="scss" scoped>

.container{
  height: 305px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.image-container{
  height: 80px;
  width: 80px;
  border-radius: 50%;
  background-color: #ECFAFD;
  display: flex;
  justify-content: center;
  align-items: center;
}

.mt-20{
  margin-top: 20px;
}

.mt-8{
  margin-top: 8px;
}

.text-align-center{
  text-align: center;
}

p {
  line-height: 1.5;
}
.resend-text{
  text-decoration: underline;
  margin-top: 20px;
}
</style>



// WEBPACK FOOTER //
// src/components/widget/widget-notification-message.vue